import {
  Card,
  List,
  Link,
  ListSubheader,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    small: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginLeft: 3,
    },
    mail: {
      width: theme.spacing(4),
      height: theme.spacing(3),
      marginLeft: 3,
    },
    loc: {
      width: "25px",
      height: "32px",
      marginLeft: 7,
    },
  })
);

function ContactInfoCard({ item }) {
  const classes = useStyles();
  return (
    <Card>
      <List dense={true} subheader={<ListSubheader color="primary">Kontaktinformationen</ListSubheader>}>
        <ListItem>
          <ListItemAvatar>
            <Avatar
              variant="square"
              src={`/assets/images/newfacilities/loc36.png`}
              className={classes.loc}
            ></Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={item.address.streetAndHouseNumber}
            secondary={
              <span style={{ color: "#212121" }}>{item.address.areaCode + " " + item.address.area}</span>
            }
          />
        </ListItem>
        {item.phone && item.phone !== "-" && (
          <ListItem>
            <ListItemAvatar>
              <Avatar
                style={{ backgroundColor: "white" }}
                src={`/assets/images/newfacilities/phone.png`}
                className={classes.small}
              ></Avatar>
            </ListItemAvatar>
            <ListItemText primary={item.phone} />
          </ListItem>
        )}
        {item.email && item.email !== "-" && (
          <ListItem>
            <ListItemAvatar>
              <Avatar
                variant="square"
                src={`/assets/images/newfacilities/mail.png`}
                className={classes.mail}
              ></Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography variant="subtitle2" style={{ color: "#7ED321" }}>
                  <Link href={`mailto:${item.email}`} onClick={(event: any) => console.log("email")}>
                    {item.email}
                  </Link>
                </Typography>
              }
            />
          </ListItem>
        )}
        {item.homepage && item.homepage !== "-" && (
          <ListItem>
            <ListItemAvatar>
              <Avatar
                variant="square"
                src={`/assets/images/newfacilities/web.png`}
                className={classes.small}
              ></Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography variant="subtitle2" style={{ color: "#7ED321" }}>
                  <Link href={`${item.homepage}`} onClick={(event: any) => console.log("homepage")}>
                    {item.homepage}
                  </Link>
                </Typography>
              }
            />
          </ListItem>
        )}
      </List>
    </Card>
  );
}

export default ContactInfoCard;
